(function () {
  if (window.__sectionFaqsAccordion) return;
  window.__sectionFaqsAccordion = true;

  function toggleFaqItem(wrapper) {
    var item = wrapper.closest('.section-faqs__item');
    if (!item) return;
    item.classList.toggle('active');
    if (wrapper.hasAttribute('aria-expanded')) {
      wrapper.setAttribute('aria-expanded', item.classList.contains('active') ? 'true' : 'false');
    }
  }

  document.addEventListener('click', function (event) {
    var wrapper = event.target.closest('.section-faqs__question-wrapper');
    if (!wrapper) return;
    toggleFaqItem(wrapper);
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Enter' && event.key !== ' ') return;
    var wrapper = event.target.closest('.section-faqs__question-wrapper');
    if (!wrapper || event.target !== wrapper) return;
    event.preventDefault();
    toggleFaqItem(wrapper);
  });
})();
